import React from 'react'
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import { NavLink, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import { getJournals } from '../../store/actions/journalActions'
import { changeProject, openProjectModal } from '../../store/actions/projectActions'
import Select from 'react-select';
import { getProjects } from '../../store/actions/projectActions';
import { withRouter } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import withStyles from "@material-ui/core/styles/withStyles";
import { compose } from 'redux'
import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import { Redirect } from 'react-router-dom'
import Checkboxes from './Checkboxes'

class SignedInLinks extends React.Component {  

  constructor(props) {
    super(props);
    this.state = {
      menuSelectedPopup: false, 
      menuSelectedPopupAnchor: null
    };
    
  }

  menuSelected = (ev) => {
    console.log("Menu selected");
    this.setState({menuSelectedPopup: true, menuSelectedPopupAnchor: ev.currentTarget});
    ev.currentTarget.blur();
     
  }

  hideMenuPopup = (ev) => {
    this.setState({menuSelectedPopup: false});
    
  }
  handleChange = (selectedOption) => {
    if (selectedOption.value !== "add-new") {
      this.props.changeProject(selectedOption.value.companyName, selectedOption.value.projectName);
    
      console.log(`Option selected:`, selectedOption);
    } else {
      this.props.openProjectModal(true);
    }
    
  }

  render() {
  const { classes, projects, selectedProject } = this.props;

  var selectedOption = {};
  let options = new Array();
  if ((projects !== null) && (projects !== undefined)) {
    

    for (var i = 0; i < projects.length; i++) {
      let thisOption = {};
      thisOption.label = projects[i].projectName;
      thisOption.value = projects[i];
      options.push(thisOption);
      
    }

    let thisOption = {};
    thisOption.label = "Add New Project ...";
    thisOption.value = "add-new";
    options.push(thisOption);
    
    if ((selectedProject !== null) && (selectedProject !== undefined)) {
      selectedOption.label = selectedProject.projectName;
    }
  } else {
    this.props.getProjects();
  }
  const selLen = 450;
  const selLenPx = '' + selLen + 'px';
  /*const customControlStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 32,
      height: 32,
      width: selLen,
      background: "#BBBBBB",
      autoWidth: true,
      
      borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "yellow" : "green",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        borderColor: state.isFocused ? "yellow" : "green"
      },
      padding: "10px",
      margin: "10px",
    }),*/

    const customControlStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 32,
        
        width: selLen,
        background: "#ffffff",
        autoWidth: true,
        
        borderRadius: state.isFocused ? "0px 0px 0 0" : 3,
        // Overwrittes the different states of border
        borderColor: state.isFocused ? "yellow" : "green",
        // Removes weird border around container
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          // Overwrittes the different states of border
          borderColor: state.isFocused ? "yellow" : "green"
        },
        padding: "0px",
        margin: "0px",
      }),
    
    menu: base => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      marginTop: 0,
      zIndex: 5
    }),
    menuList: base => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
      color: "#000000"
    })
  };


  
  return (
    
    <div className="grey darken-3" style={{display: 'flex', flexDirection: 'row', justifyContent: "flex-end", width: '100%', alignItems: "stretch", marginLeft: "50px"}}>
    
    <div style={{flexGrow: 7, display: 'flex', flexDirection: 'row'}}>
 
    
    <Select
          styles={customControlStyles}
          value={selectedOption !== undefined ? selectedOption : "Select..."}
          onChange={this.handleChange}
          options={options}
          
          /></div>
    
        <div style={{flexGrow: 1}}>
      <ul>
        
       
        <li><Fab style={{color: "#dddddd", fontSize: "18px"}} className="btn btn-floating green darken-1" onClick={this.menuSelected} >
          {this.props.profile.initials}
        </Fab></li>
      </ul>

      {  (<Menu id="simple-menu" anchorEl={this.state.menuSelectedPopupAnchor} anchorOrigin={{horizontal: 'left', vertical: 'bottom'}} open={this.state.menuSelectedPopup} onChanged={this.hideMenuPopup} onClose={this.hideMenuPopup}>
            
              <MenuItem value={"Log Out"} onClick={this.props.signOut}>Log Out</MenuItem>
                
            )
            })}  
            
          </Menu>)
        }
      </div>
    </div>

  )
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  const projects = state.project.projects;
 
  return{
    projects: state.project.projects,
    selectedProject: state.project.selectedProject
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
    getJournals: (companyName, projectName) => dispatch(getJournals(companyName, projectName)),
    getProjects: () => dispatch(getProjects()),
    changeProject: (companyName, projectName) => dispatch(changeProject(companyName, projectName)),
    openProjectModal: (open) => dispatch(openProjectModal(open))
  }
}


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(headerStyle)
)(withRouter(SignedInLinks))



// WEBPACK FOOTER //
// ./src/components/layout/SignedInLinks.js